






















import Vue from 'vue'

export default Vue.extend({
  name: 'ActionSheet',

  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: 'Options',
    },
  },
  watch: {
    visible(val: boolean) {
      if (!this.$screen.isMobile(this.$mq)) {
        return
      }
      val === true ? this.$bodyScroll.disable() : this.$bodyScroll.enable()
    },
  },
  beforeDestroy() {
    if (this.$screen.isMobile(this.$mq)) {
      this.$bodyScroll.enable()
    }
  },
})
